<template>
  <div>
    <v-row>
      <v-col
        v-for="(item, index) in gallery"
        :key="item.id"
        :id="item.id"
        class="d-flex child-flex"
        cols="2"
      >
        <v-lazy transition="fade-transition">
        <v-card>
          <v-card-text class="pa-0">
            <v-img
            :src="API_BASE_URL + '/uploads/' + item.thumb_url"
            :lazy-src="API_BASE_URL + '/uploads/' + item.document_url"
            aspect-ratio="1"
            class="grey lighten-2"
            height="150px"
            width="250px"
            @click="
              selected_item = index;
              imageDialog = true;
            "
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
            icon
            fab
            small
            color="primary"
            name="delete_gallery"
            title="Delete Gallery"
            @click="
              imageDialog = false;
              confirmDelete(item.id);
            "
          >
            <v-icon small style="font-size: 20px"> mdi-close </v-icon>
          </v-btn>
          </v-card-actions>
        </v-card>
        </v-lazy>
      </v-col>
    </v-row>
    <v-dialog
      v-model="imageDialog"
      v-if="imageDialog"
      style="overflow-y: hidden !important; overflow-x: hidden !important;"
    >
      <v-card>
        <v-card-text class="" style="padding: 0 0px 0px !important;position:relative">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            color="primary"
            style="float: right;position:absolute;z-index:999;right:0"
            @click="imageDialog = false"
          >
            <v-icon dark> mdi-close </v-icon>
          </v-btn>
          <v-carousel  v-model="selected_item" hide-delimiters>
            <v-carousel-item 
            v-for="(item,i) in actual_gallery"
            :key="i"
            :src="API_BASE_URL + '/uploads/' + item.document_url"
            style="position: relative;"
          >           
            <div
              class="text-body-1 block"
              :style="{ position: 'absolute', bottom: '10px',zIndex: 9999999, width: '100%' }"
            >
              <div class="primary mx-auto" :style="{ height: '30px', width: '70px', lineHeight: '30px', textAlign: 'center', color: 'white', borderRadius: '30px'}">
                {{ `${i + 1} / ${ actual_gallery.length }` }}
              </div>
            </div>
          </v-carousel-item>
          </v-carousel>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Confirm!! </v-card-title>
        <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDocument(delete_id)">
            yes
          </v-btn>
          <v-btn color="primary" text @click="closeDialog"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template> 

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      selected_item: 3,
      gallery: [],
      actual_gallery: [],
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      delete_id: "",
      deleteDialog: false,
    };
  },
  props: ["loading"],
  watch: {
    loading: function () {
      if (!this.loading) {
        this.getDetails();
      }
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getDetails() {
      let _self = this;
      _self.$axios
        .get(`societyadmin/gallery/` + _self.$route.params.id + `/image`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.gallery = data.gallery;
            _self.actual_gallery = data.gallery;
            console.log("gallery", _self.gallery);
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    deleteDocument(Id) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/gallery/documents/" + Id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            console.log(data.status);
            this.getDetails();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    imgClick(item) {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
      console.log("this.delete_id", this.delete_id);
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
  },
  created() {
    this.getDetails();
  },
};
</script>

<style>
.v-dialog {
  overflow-y: hidden !important;
}
.v-dialog .v-image__image--cover {
background-size: contain  !important;

}
</style>